import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import Badge from '../components/Badge';
import { EventBasicInfo, EventTextBlock } from '../components/EventInfoSections';

export default function EventInfo() {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/events/current')
      .then((r) => setEvent(r.data))
      .catch(() => setEvent(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="flex justify-center py-16"><div className="animate-spin rounded-full h-8 w-8 border-2 border-ocean-500 border-t-transparent" /></div>;
  }

  if (!event) {
    return (
      <div className="max-w-3xl mx-auto card text-center py-14">
        <p className="text-slate-400 text-sm mb-3">Aktuell ist kein Event aktiv — schau bald wieder vorbei.</p>
        <Link to="/archiv" className="text-sm font-semibold text-ocean-600 hover:text-ocean-800 no-underline">
          Vergangene Events im Archiv ansehen →
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-ocean-900 tracking-tight">{event.name}</h1>
        <div className="flex items-center gap-3 mt-2 flex-wrap">
          <Badge status={event.status} />
          {event.location && (
            <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(event.location)}`}
              target="_blank" rel="noopener noreferrer"
              className="text-sm text-slate-500 hover:text-ocean-600 no-underline">
              📍 {event.location}
            </a>
          )}
        </div>
      </div>

      <EventBasicInfo event={event} />

      <div>
        <p className="section-title mb-2">Regeln</p>
        <EventTextBlock event={event} field="rules" label="Regeln" showLabel={false} />
      </div>
      <div>
        <p className="section-title mb-2">AGB</p>
        <EventTextBlock event={event} field="agb" label="AGB" showLabel={false} />
      </div>
      <div>
        <p className="section-title mb-2">FAQ</p>
        <EventTextBlock event={event} field="faq" label="FAQ" showLabel={false} />
      </div>
    </div>
  );
}
